import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { NgForOf, NgIf, DatePipe } from '@angular/common';

@Component({
  selector: 'app-booking-calendar',
  standalone: true,
  imports: [NgForOf, NgIf, DatePipe],
  templateUrl: './booking-calendar.component.html',
  styleUrls: ['./booking-calendar.component.scss']
})
export class BookingCalendarComponent implements OnChanges {
  @Input() currentDate: Date = new Date();
  @Input() counts: Record<string, number> = {};
  @Input() selectedDateStr: string | null = null;

  @Output() dateSelected = new EventEmitter<string>();
  @Output() monthChanged = new EventEmitter<Date>();

  public today = new Date();

  daysInMonth: (number | null)[] = [];
  weekDays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentDate']) {
      this.generateCalendar();
    }
  }

  generateCalendar() {
    const year = this.currentDate.getFullYear();
    const month = this.currentDate.getMonth();

    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    let startDayOfWeek = firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1;

    const days: (number | null)[] = [];
    for (let i = 0; i < startDayOfWeek; i++) {
      days.push(null);
    }
    for (let i = 1; i <= lastDay.getDate(); i++) {
      days.push(i);
    }
    this.daysInMonth = days;
  }

  getDateString(day: number): string {
    const y = this.currentDate.getFullYear();
    const m = (this.currentDate.getMonth() + 1).toString().padStart(2, '0');
    const d = day.toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  selectDay(day: number | null) {
    if (!day) return;
    const dateStr = this.getDateString(day);
    this.dateSelected.emit(dateStr);
  }

  changeMonth(offset: number) {
    const newDate = new Date(this.currentDate);
    newDate.setMonth(newDate.getMonth() + offset);
    this.monthChanged.emit(newDate);
  }

  getCount(dateStr: string): number {
    return this.counts[dateStr] || 0;
  }

  protected readonly Math = Math;
}
